import { render, staticRenderFns } from "./MyDesignsV3.vue?vue&type=template&id=4d918864&scoped=true"
import script from "./MyDesignsV3.vue?vue&type=script&lang=js"
export * from "./MyDesignsV3.vue?vue&type=script&lang=js"
import style0 from "./MyDesignsV3.vue?vue&type=style&index=0&id=4d918864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d918864",
  null
  
)

export default component.exports